import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {I18nUtils} from "../../../../i18n/I18nUtils";
import StateManager from "../../../shared/utils/StateManager";
import DocumentSchemaType from "../../../shared/model/DocumentSchemaType";
import DocumentsTab from "../../../shared/components/tabs/documents/DocumentsTab";
import * as exportOutsourceDocsActions from "../../actions/exportOutsourceDocsActions";

class ExportOutsourceDocsCardTabLinked extends React.Component {

  static TAB_ID = 'linked';

  static renderTabHeader() {
    return (
      <li role="presentation" className="">
        <a href={'#' + this.TAB_ID} data-toggle="tab" aria-expanded="true">{I18nUtils.tr('TR_VINCULADOS').toUpperCase()}</a>
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade" id={ExportOutsourceDocsCardTabLinked.TAB_ID}>
        <DocumentsTab
          id={StateManager.EXP_DOC_TAB_LINKED}
          title={I18nUtils.tr('TR_DOCUMENTOS_VINCULADOS')}
          documentSchemaType={DocumentSchemaType.LINKED}
          companyId={this.props.companyId}
          selectedIds={this.props.selectedIds}
          actionSelectItem={this.props.exportOutsourceDocsActions.checkLinkedDocument}
          actionSelectAll={this.props.exportOutsourceDocsActions.checkLinkedDocuments}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const documentIds = state.exportOutsourceDocs.linkedDocuments.map(document => document.id);
  return {
    selectedIds: documentIds,
  }
};

const mapDispatchToProps = dispatch => ({
  exportOutsourceDocsActions: bindActionCreators(exportOutsourceDocsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportOutsourceDocsCardTabLinked)

ExportOutsourceDocsCardTabLinked.propTypes = {
  companyId: PropTypes.string.isRequired,
};

ExportOutsourceDocsCardTabLinked.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/export/ExportOutsourceDocsCardTabLinked.js